import { render } from "./BottomComponent.vue?vue&type=template&id=be5ebe9e&scoped=true"
import script from "./BottomComponent.vue?vue&type=script&lang=js"
export * from "./BottomComponent.vue?vue&type=script&lang=js"

import "./BottomComponent.vue?vue&type=style&index=0&id=be5ebe9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5ebe9e"]])

export default __exports__